import { createFileRoute } from '@tanstack/react-router'
import { useSuspenseQuery } from '~/services'
import { AdvancedConfigSection } from '~/features/webchat/components'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()

  const { plan } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId }).data

  return <AdvancedConfigSection workspaceId={workspaceId} botId={botId} plan={plan} />
}
